import { loginRequest as $api } from 'api_connection';
import { loginActions as $a } from 'storage/actions';
import authReducer from 'storage/reducers/auth';
import { routes } from "./urls";
import { getRootPage } from './pages';
import { NO_SECTION_MESSAGE, setAccessDeniedMessage } from './access-denied';

const ROOT = '/';

const PENDING_ROUTE = 'pending_route';

/**
 * Guarda el destino al que el usuario queria ir antes de mandarlo al login.
 *
 * Sin esto, una URL compartida como /redactar-base-de-conocimiento?kbid=5 se
 * pierde: el login aterriza siempre en el dashboard por privilegio.
 *
 * router() llama a Middleware con location.pathname a secas, asi que el query
 * string hay que recuperarlo de location.search.
 */
const _savePendingRoute = (path) => {
   if(!path || path === ROOT) return;
   let full = path.includes('?') ? path : path + location.search;
   if(!_isKnownRoute(full)) return;
   sessionStorage.setItem(PENDING_ROUTE, full);
}

const _isKnownRoute = (url) => routes.some(route => route.path === url.split('?')[0]);

/**
 * Devuelve el destino pendiente y lo consume. Se valida contra la tabla de
 * rutas para no redirigir a lo que sea que hubiera en la barra.
 */
export const takePendingRoute = () => {
   let pending = sessionStorage.getItem(PENDING_ROUTE);
   sessionStorage.removeItem(PENDING_ROUTE);
   if(!pending || !_isKnownRoute(pending)) return null;
   return pending;
}

const Middleware = async(path) => {
   let { user, token, privileges } = authReducer();

   if(path == '/status') return path;

   if (!Boolean(user?.pid) || !Boolean(token?.length)) {
      _savePendingRoute(path);
      return ROOT;
   }

   // Toda sesión abierta pasa por aquí, tenga o no "recuérdame": antes, sin
   // él, una pestaña nueva llegaba a cualquier ruta sin comprobar privilegios.
   let rootPage = getRootPage(privileges);
   if(!rootPage){
      await _denyAccess(user.pid, token);
      return ROOT;
   }

  //  let sessionData = await getRememberMe(user.pid, token);
  //  if(!sessionData.remember_me) return ROOT;

   return path === ROOT ? rootPage : _getPath(privileges, path, rootPage);
}

/**
 * Quien no tiene acceso a ninguna sección no puede usar el CMS: se cierra su
 * sesión, también en cms-api, y el login muestra el motivo.
 */
const _denyAccess = async(pid, ses) => {
   // Antes del logout: si la sesión ya caducó, la API recarga la página
   setAccessDeniedMessage(NO_SECTION_MESSAGE);
   sessionStorage.removeItem(PENDING_ROUTE);
   await new Promise(resolve => $api.logout({ pid, ses }, resolve, resolve));
   // Si el logout falló, la sesión local se borra igualmente
   $a.logoutAction();
   sessionStorage.removeItem('remember_me');
}

const getRememberMe = (pid, ses) => new Promise((resolve) => {
   $api.sessionGetData({ pid: `${pid}`, ses },
      (resp) => {
         if(resp.remember_me){
            sessionStorage.setItem('remember_me', resp.remember_me);
         }else{
            $a.logoutAction();
         }
         resolve(resp);
      },
      (error) => console.error(error)
   );
});

const _getPath = (privileges, path, rootPage) => {
   let params = path.split('?')[1] ? `?${path.split('?')[1]}` : ''; 
   path = path.split('?')[0];
   let route = routes.find(p => p.path === path);
   // Ruta desconocida: el router muestra "página no encontrada"
   if(!route) return path + params;
   let _privileges = privileges.map(privilege => privilege.privilege_id);
   if(route.privilege === 'none') return path + params;
   if(Array.isArray(route.privilege)){
      let hasPrivileges = route.privilege.some(i => _privileges.includes(i))
      if(hasPrivileges) return path + params;
   }
   if(_privileges.includes(route.privilege)) return path + params;
   return rootPage;
}

export default Middleware;

